import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {Card} from '@spaced-out/ui-design-system/lib/components/Card';
import {SubTitleSmall} from '@spaced-out/ui-design-system/lib/components/Text';

import {isTimezoneSupported} from '../../utils/booking';
import {selectTimezone} from '../../selectors/timezoneSelectors';
import {RootMachineContext} from '../../machines/rootMachine/rootMachine.context';
import {TimezonePicker as SchedulerTimezonePicker} from 'src/components/scheduler/lib/timezone-picker/timezone-picker';

import css from './timezone-picker.css';


export const TimezonePicker = () => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  const rootRef = RootMachineContext.useActorRef();
  const timezone = RootMachineContext.useSelector(selectTimezone);
  const timezoneSupported = timezone ? isTimezoneSupported(timezone) : false;

  const onChangeTimezone = (updatedTimezone: string) => {
    rootRef.send({type: 'timezone.set', timezone: updatedTimezone});
  };

  return (
    <Card classNames={{wrapper: css.timezonePickerCard}}>
      <SubTitleSmall>
        {t('Please_select_a_timezone', 'Please select a timezone')}
      </SubTitleSmall>
      <SchedulerTimezonePicker
        value={timezoneSupported ? timezone : null}
        onChange={(timezone) => onChangeTimezone(timezone)}
        classNames={{container: css.timezonePicker}}
      />
    </Card>
  );
};
